import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { GetCountryResponseInterface } from '../definitions/get-country-response.interface';

@Injectable({ providedIn: 'root' })
export class GetCountriesService {
  constructor(private client: HttpClient, private configService: ConfigService) {}

  public getCountries(): Observable<Array<GetCountryResponseInterface>> {
    const url = `${this.configService.config.rest.apiV2Url}/countries`;

    return this.client.get<Array<GetCountryResponseInterface>>(url).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
